<template>
  <div class="trade-detail">
    <div class="headerWrapper">
      <div class="goBack"
        v-tap
        @tap="goBack"></div>
      <i class="icon iconfont left">&#xe604;</i>
      <div class="right-wrapper">
        <div class="title-item title-left">
          <span class="label">{{pageData.account.title}}</span>
          <span class="span-value" :style="{ fontSize: dynamicFontSize(pageData.account.value) }">{{pageData.account.value}}</span>
        </div>
        <div class="title-item title-center">
          <span class="label">{{pageData.rights.title}}</span>
          <span class="span-value" :style="{ fontSize: dynamicFontSize(pageData.rights.value) }">{{pageData.rights.value}}</span>
        </div>
        <div class="title-item title-right">
          <span class="label">{{pageData.usable.title}}</span>
          <span class="span-value" :style="{ fontSize: dynamicFontSize(pageData.usable.value) }">{{pageData.usable.value}}</span>
        </div>
      </div>
    </div>
    <!--<orderMenu></orderMenu>-->

    <div class="menu">
      <ul>
        <li v-for="(item,index) in menuData"
          :key="index"
          v-tap
          @tap="link(index)">
          <i class="icon iconfont"
            v-html="item.tobarIcon"></i>
          <span :class="{tobarContent:isActive==index}">{{item.tobarContent}}</span>

        </li>
      </ul>
    </div>

    <div class="order-w-1"
      v-if="isActive==0">
      <div class="price-wrapper">
        <div class="price-left"
          ref="tbState"
          v-tap
          @tap="tbState=true">
          <span v-if="!insertPage.targetId">
            <i class="icon iconfont price-left-icon">&#xe668;</i>合约</span>
          <span v-if="tbState||insertPage.targetId">{{insertPage.targetId}}</span>
          <i class="icon iconfont price-c-1"
            v-tap
            @tap.stop="goToMarketDetail">&#xe67e;</i>
        </div>

        <span>最新价
          <i class="proces">{{insertPage.tick.latestPrice}}</i>
        </span>
        <span>买一
          <i class="proces buy">{{insertPage.tick.bidPrice1}}</i>
          <i class="proces buy">{{insertPage.tick.bidVolume1}}</i>
        </span>
        <span>卖一
          <i class="proces selt">{{insertPage.tick.askPrice1}}</i>
          <i class="proces selt">{{insertPage.tick.askVolume1}}</i>
        </span>

      </div>
      <div>
        <!-- 输入框 -->
        <div class="input-wrapper">
          <span class="imput">
            <i class="icon iconfont reduce">&#xe64f;</i>
            <input ref="xxxx"
              class="value"
              type="text"
              placeholder="请输入手数"
              v-model="insertPage.volume"
              @focus="flage=true"
              readonly="readonly"
              maxlength="10" />
          </span>
          <span class="imput">
            <i class="icon iconfont reduce">&#xe64f;</i>
            <input ref="yyyy"
              class="value"
              type="text"
              :placeholder="insertPage.inputPriceHolder"
              v-model="insertPage.inputPrice"
              @focus="flage2=true"
              readonly="readonly"
              maxlength="13" />
          </span>
        </div>

        <!-- 买多   卖空  平仓 -->
        <div class="input-wrapper place_wrapper">
          <div v-for="(item,index) in orderButton"
            :key="index"
            class="place_oreder"
            :style='item.color'
            @click="orderClick(index,item)"
            @touchstart='handleTouchStart(index, item)'
            @touchend='handleTouchEnd(index, item)'>
            <p ref="changes">{{item.price}}</p>
            <span></span>
            <p>{{item.text}}</p>
          </div>
        </div>

        <!-- 买多,卖空,平仓弹出层 -->
        <div class="store-cx"
          v-if="sureOrder">
          <div class="store-cx-con">
            <h3 class="tit">确认要下单吗？</h3>
            <hr style="background-color: #26a2ff;height:1px" />
            <p class="store-con">
              {{insertPage.targetId}},
              {{sele_deal}},
              {{closing}},
              价格{{insertPage.price}},
              手数<span v-if="!quickFlage">{{insertPage.volume}}</span><span v-else>{{quickHandle}}</span></p>
            <div class="store-click">
              <vButton class="store-cancel"
                v-tap
                @tap="sureOrder=false">取消</vButton>
              <vButton class="store-enter"
                v-tap
                @tap="clickEvent">确定</vButton>
            </div>
          </div>
        </div>

        <!-- 下单显示的持仓 -->
        <div class="store-c-1">
          <span v-for="(item,index) in menuTilte"
            :key="index">{{item}}</span>
        </div>
        <div class="order_content">
          <div v-for="(item,index) in menuValue"
              :key="index">
            <div class="store-c-2"
              :class="{'sele_bg':insertPage.posSelect==item.id}"
              v-tap
              @tap="orderImfor(item.id)">
              <span>{{item.targetId}}</span>
              <span>{{item.type}}</span>
              <span>{{item.vol}}</span>
              <span>{{item.closeOut}}</span>
              <span>{{item.money}}</span>
              <span :class="{'or_color': item.loss >= 0,'green_color':item.loss<0}">{{item.loss}}</span>
                <!-- <span v-for="(item2,index2) in item"
                  :key="index2"
                  :class="{'or_color':index2 == 5&&item2 >= 0,'green_color':index2 == 5&&item2<0}">{{item2}}</span><br/> -->
              </div>
            <div :class="['options',{showOptions: item.id == insertPage.posSelect}]">
              <span @click="quickBackhand(item)">快捷反手</span>
              <span @click="shortcutPositions(item)">快捷锁仓</span>
              <span @click="shortcutCloseOuts(item)">快捷平仓</span>
              <span @click="condition(item)">云条件单</span>
              <span @click="checkFullStop(item, index)">止盈止损</span>
            </div>
          </div>
        </div>

        <!-- 键盘1 -->

        <NumKeyboard v-if='flage'
          :title='"最大可买手数:"+buyVol+"　　最大可卖手数:"+sellVol'
          v-model="insertPage.volume"
          :exclude="[$refs.xxxx]"
          :isInteger="true"
          @close="handleCloseKey" />

        <TradeKeyboard v-if='flage2'
          :tick="insertPage.tick"
          :exclude="[$refs.yyyy]"
          :isInteger="false"
          :price.sync="insertPage.inputPrice"
          :boardPrice="boardPrice"
          :priceType.sync="insertPage.priceMode"
          :priceHolder.sync="insertPage.inputPriceHolder"
          @change="updateButtonPrice"
          @close="handleCloseKey2">
          <!-- 注释传参 -->
          <!-- :priceTicks="priceTicks.priceTick" -->
        </TradeKeyboard>

      </div>
    </div>

    <div class="store-w-1"
      v-if="isActive==1">
      <div class="store-c-1">
        <span v-for="(item,index) in menuTilte"
          :key="index">{{item}}</span>
      </div>

      <div class="shadow2">
        <div class="store-c-2"
          v-for="(item,index) in menuValue"
          :key="index">
          <span>{{item.targetId}}</span>
          <span>{{item.type}}</span>
          <span>{{item.vol}}</span>
          <span>{{item.closeOut}}</span>
          <span>{{item.money}}</span>
          <span :class="{'or_color': item.loss >= 0,'green_color':item.loss<0}">{{item.loss}}</span>
          <!-- <span v-for="(item2,index2) in item"
            :key="index2"
            :class="{'or_color':index2 == 5&&item2 >= 0,'green_color':index2 == 5&&item2<0}">{{item2}}</span><br/> -->
        </div>
        <div class="store-cx"
          v-if="all_pc">
          <div class="store-cx-con">
            <h3 class="all_tit">确认全部平仓吗？</h3>
            <div class="store-click">
              <vButton class="store-cancel"
                v-tap
                @tap="all_pc=false">取消</vButton>
              <vButton class="store-enter"
                v-tap
                @tap="all_pcs">确定</vButton>
            </div>
          </div>
        </div>
      </div>
      <vButton class="order"
        type="primary"
        v-tap
        @tap="all_pc=true">{{buttonTitle}}</vButton>
    </div>

    <div class="store-w-1"
      v-if="isActive==2">
      <div class="store-c-1">
        <span v-for="(item,index) in menuTilte"
          :key="index">{{item}}</span>
      </div>

      <div class="cancel-order-wrapper">
        <div class="store-c-2"
          v-for="(item,index) in cancelOrderValue"
          :key="index"
          v-tap
          @tap="show_cx(item,index)">
          <span v-for="(item2,index2) in item"
            :key="index2">{{item2}}</span><br/>
        </div>
      </div>
      <div class="store-cx"
        v-if="data_cx">
        <div class="store-cx-con">
          <h3 class="tit">确认撤单吗？</h3>
          <hr style="background-color: #26a2ff;height:1px" />
          <p class="store-con">{{store_name}},{{store_type}},委托价{{store_num2}}<br/>委托量{{store_num1}},挂单量{{store_money}}
          </p>
          <div class="store-click">
            <vButton class="store-cancel"
              v-tap
              @tap="data_cx=false">取消</vButton>
            <vButton class="store-enter"
              v-tap
              @tap="sure_cd">确定</vButton>
          </div>
        </div>
      </div>
      <div class="store-cx"
        v-if="all_cx">
        <div class="store-cx-con">
          <h3 class="all_tit">确认全部撤单吗？</h3>
          <div class="store-click">
            <vButton class="store-cancel"
              v-tap
              @tap="all_cx=false">取消</vButton>
            <vButton class="store-enter"
              v-tap
              @tap="all_cd">确定</vButton>
          </div>
        </div>
      </div>
      <vButton class="order"
        type="primary"
        v-tap
        @tap="all_cx=true">{{buttonTitle}}</vButton>

    </div>

    <div v-if="isActive==3"
      class="clearfix">
      <div class="money-w-1"
        v-for="(item,index) in money"
        :key="index">
        <div class="money-c-1">
          <span class="money-c-2">{{index}}</span><br/>
          <span class="money-c-value">{{item}}</span>
        </div>
      </div>
    </div>

    <div class="search"
      v-if="isActive==4">
      <div class="vessel">
        <TradeSearch :tableData="tradeMenuValue"
          v-if="buttonSearch" />
        <OrderSearch :tableData="orderMenuValue"
          v-else />
      </div>
      <!--成交查询按钮-->
      <vButton class="order-left"
        :class="{'search-checked':searchCheckedState==0}"
        v-tap
        @tap="searchButLink(0)">
        {{buttonTitleLeft}}
      </vButton>

      <!--报单查询按钮-->
      <vButton class="order-right"
        :class="{'search-checked':searchCheckedState==1}"
        v-tap
        @tap="searchButLink(1)">
        {{buttonTitleRight}}
      </vButton>
    </div>

    <TargetKeyboard v-if='tbState'
      :exclude="[$refs.tbState]"
      @submit="value=>choiceTargetId(value)"
      @close="tbState=false" />
         <!-- 止盈止损 -->
    <div :class='["CheckFullStop", {showPage: checkFullStopFlage}]'>
      <CheckFullStop
      :datas ="checkFullStopData"
      :positions.sync ='checkFullStopVolume'
      :tids ='selectTids'
      :titles ='checkFullStopTitle'
      :showFlage="checkFullStopFlage"
      :tick ='insertPage.tick'
      :priceTicks="insertPage.tick.priceTick"
      :priceType.sync="insertPage.priceMode"
      :priceData.sync='insertPage'
      @hiddenPage="handleHiddenPage"
      ref="CheckFullStop"
      />
    </div>
    <!-- 提醒选择合约 -->
    <h2 class="alert_imfor"
      v-if="auto_flage">{{warning}}</h2>
  </div>
</template>

<script>
import art from "../../../static/js/proto/art/Art.js";
import orderMenu from "@/components/common/orderMenu";
import { Button } from "mint-ui";
import model from "../../../static/js/proto/Model.js";
import front from "../../../static/js/proto/CtpFront.js";
import TradeKeyboard from './components/Tradekeyboard/TradeKeyboard.vue';
import TargetKeyboard from "@/views/components/TargetKeyboard/TargetKeyboard.vue";
import TradeSearch from "./components/TradeSearch/TradeSearch.vue";
import OrderSearch from "./components/OrderSearch/OrderSearch.vue";
import CheckFullStop from './components/CheckFullStop/CheckFullStop';
import * as utils from '@/utils/utils';

export default {
  components: {
    orderMenu,
    vButton: Button,
    TradeKeyboard,
    TargetKeyboard,
    TradeSearch,
    OrderSearch,
    CheckFullStop,
  },
  data() {
    return {
      name: "trade-detail",
      flage: false,
      orderButton: [
        {
          price: "--",
          text: "买多",
          color: "background-color: #EF544F;"
        },
        {
          price: "--",
          text: "卖空",
          color: "background-color: #2BCE99;"
        },
        {
          price: "",
          text: "平仓",
          color: "background-color: #808080;"
        }
      ],
      store_name: "",
      store_type: "",
      store_money: "",
      store_num1: "",
      store_num2: "",
      data_cx: false,
      all_cx: false,
      all_pc: false,
      num: "",
      sureOrder: false,
      orderIndex: "",
      deal: ["买", "卖"],
      sele_deal: "",
      auto_flage: false,
      closing: "开仓",
      mon_req: true,
      flage2: false,
      warning: "",
      price_type: ["排队价", "对手价", "最新价", "市价", "超价"],
      // 按数值大小取小数位数
      fmtDouble: function(value) {
        if (value > 10000) {
          return Math.round(value);
        } else if (value > 1000) {
          return Math.round(value * 10) / 10;
        } else if (value > 100) {
          return Math.round(value * 100) / 100;
        }
        return Math.round(value * 1000) / 1000;
      },
      currentProductId: "ag",
      sumExchangeName: ["上期所", "上期能源", "大商所", "郑商所", "中金所", "广期所"],
      contractData: [],
      pageData: {
        account: { title: "账号", value: "" },
        rights: {
          title: "权益",
          value: ""
        },
        usable: {
          title: "可用",
          value: ""
        },
        profitAloss: {
          title: "盈亏",
          value: "-880.00"
        },
        desirable: {
          title: "可取",
          value: "0.00"
        }
      },
      order1: ["买", "卖"],
      order2: ["开仓", "平今", "平仓"],
      checkedTab: 0,
      menuTilte: ["合约", "多空", "手数", "可平", "开仓均价", "浮动盈亏"],
      menuValue: [],
      //menuValue: [["TA809", "买", 32, 32, 5682.25, 280],["TA809", "买", 32, 32, 5682.25, 280],],
      orderMenuValue: [], //查询-报单
      tradeMenuValue: [], //查询-成交
      isActive: "",
      buttonTitleLeft: "成交查询",
      buttonTitleRight: "报单查询",
      buttonSearch: false,
      searchCheckedState: 0,
      menuData: [
        {
          tobarLink: "/home/order",
          tobarIcon: "&#xe624;",
          tobarContent: "下单"
        },
        {
          tobarLink: "/home/store",
          tobarIcon: "&#xe7b9;",
          tobarContent: "持仓"
        },
        {
          tobarLink: "/home/cancel",
          tobarIcon: "&#xe609;",
          tobarContent: "撤单"
        },
        {
          tobarLink: "/home/capital",
          tobarIcon: "&#xe60a;",
          tobarContent: "资金"
        },
        {
          tobarLink: "/home/query",
          tobarIcon: "&#xe603;",
          tobarContent: "查询"
        }
      ],
      buttonTitle: "",
      money: {},
      tbState: false,

      // 下单页面 XXXXXX
      insertPage: {
        tick: {},
        posSelect: 0,
        posSelects: 0,
        inputPrice: "",
        inputPriceHolder: "输入价格",
        price: "",
        volume: "",
        targetId: ""
      },
      // 传入键盘加号 按选中的价格类型开始加减
      boardPrice: '',
      cancelOrderValue: [],
      orderTick: {},
      temporaryTick: {},
      orderTicks: {},
      buyVol: '--',
      sellVol: '--',

      // 提示框款判断事件
      eventflage: '',
      eventItem: '',
      // 止盈止损
      checkFullStopFlage: false,
      checkFullStopData: '',
      checkFullStopTitle: '',
      checkFullStopVolume: '',
      selectTids: '',
      checkFullStopList: {
        direction: '',
        targetId: '',
      },
      /**快捷操作手数不安输入框里的手数来 */
      quickHandle: null,
      quickFlage: false,
    };
  },
  methods: {
    // 动态计算资金显示字号
    dynamicFontSize(val) {
      if (!val) return '0.3rem';
      const len = String(val).length;
      if (len <= 8) return '0.32rem';
      if (len <= 10) return '0.28rem';
      if (len <= 12) return '0.24rem';
      if (len <= 14) return '0.2rem';
      if (len <= 16) return '0.18rem';
      return '0.16rem';
    },
    // 跳转到行情详情
    goToMarketDetail() {
      if (this.insertPage.targetId) {
        localStorage.contractorNo = this.insertPage.targetId;
        this.$router.push({ path: "/marketDetail/" + this.insertPage.targetId });
      } else {
        utils.toast('请先选择合约');
      }
    },
    handleTouchStart(index, item) {
      switch (index) {
        case 0:
          item.color = "background-color: #772826; color: #aaa"
          break;
        case 1:
          item.color = "background-color: #18644b; color: #aaa"
          break;
        case 2:
          item.color = "background-color: #464545; color: #aaa"
          break;
      }
    },
    handleTouchEnd(index, item) {
      switch (index) {
        case 0:
          item.color = "background-color: #EF544F; color: #fff";
          break;
        case 1:
          item.color = "background-color: #2BCE99; color: #fff";
          break;
        case 2:
          item.color = "background-color: #808080; color: #fff";
          break;
      }
    },
    // 快捷反手
    quickBackhand(item) {
      if (item.closeOut == 0 || item.vol>item.closeOut) {
        this.show_hint('本持仓有冻结单, 不能进行快捷反手');
        return;
      }
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_fs'
        this.eventItem = item;
        this.quickHandle = item.vol;
        this.quickFlage = true;
      } else {
        this.shortcutCloseOut(item);
        this.shortcutPosition(item.vol);
      }
      var pos = model.positionSet.array[this.insertPage.posSelect];
      this.sele_deal =
            item.type == '卖' ? '买' : '卖';
      this.closing = '开仓';
      if (pos.direction == front.pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
    },

    // 快捷锁仓提示框判断
    shortcutPositions(item) {
      var pos = model.positionSet.array[this.insertPage.posSelect];
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_sc'
        this.quickHandle = item.vol;
        this.quickFlage = true;
      } else {
        this.shortcutPosition(item.vol);
      }
      this.sele_deal =
            pos.direction == front.pos_direct_short ?
            '买' : '卖';
      this.closing = '开仓';
      if (pos.direction == front.pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
    },

    // 快捷锁仓
    shortcutPosition(vol=null) {
      var pos = model.positionSet.array[this.insertPage.posSelect];
      if (pos.direction == front.pos_direct_short) {
        this.orderIndex = 0;
        // this.insertPage.price = this.insertPage.tick.askPrice1;
        this.insertPage.price = this.insertPage.tick.highStopPrice;
      } else {
        this.orderIndex = 1;
        // this.insertPage.price = this.insertPage.tick.bidPrice1;
        this.insertPage.price = this.insertPage.tick.lowStopPrice;
      }
      this.purchaseOrder(vol);
    },

    // 快捷平仓提示框
    shortcutCloseOuts(item) {
      this.quickHandle = item.vol;
      this.quickFlage = true;
      if (localStorage.flage === "true") {
        this.sureOrder = true;
        this.eventflage = 'shortcut_pc';
        this.eventItem = item;
      } else {
        this.shortcutCloseOut(item);
      }
      this.sele_deal =
            item.type == '卖' ? '买' : '卖';
      var pos = model.positionSet.array[this.insertPage.posSelect];
      if (pos.direction == front.pos_direct_short) {
        var price = this.insertPage.tick.highStopPrice;
      } else {
        var price = this.insertPage.tick.lowStopPrice;
      }
      this.insertPage.price = price;
      this.closing = '平仓';
    },
    // 快捷平仓
    shortcutCloseOut(item) {
      var that = this;
      var orderSet = [];
      // if (volume === undefined) volume = that.insertPage.volume;
      var volume = item.closeOut;
      if (volume == 0) {
        this.show_hint('可平手数为0')
      } else {
        var pos = model.positionSet.array[that.insertPage.posSelect];
        if (pos.direction == front.pos_direct_short) {
          var price = that.insertPage.tick.highStopPrice;
        } else {
          var price = that.insertPage.tick.lowStopPrice;
        }
        front.getCloseOrderSet(orderSet, pos, volume, price);

        // 调用前置机委托下单。
        for (var i = 0; i < orderSet.length; ++i) {
          var order = orderSet[i];
          front.insertOrder(
            order,
            rsp => {},
            error => {
                this.show_hint(error.message);
            }
          );
        }
      }
      this.sureOrder = false;
    },
    // 云条件单
    condition(item) {
      this.$router.push({
        path: "/home/condition",
        query: { targetId: item.targetId,
          type: item.type,
          closeOut: item.closeOut,
          money: this.insertPage.tick.latestPrice,
          // priceTicks: this.priceTicks.priceTick,
          Num: 2,
        }
      });
    },
    // 止盈止损
    checkFullStop(item, index) {
      // 网络断开时下单提示
      // if (this.linkLoad) {
      //   utils.toast(this.$store.state.language.v14k11);
      //   return;
      // }
      var pos = model.positionSet.array[index];
      // 获取持仓可用数量
      this.checkFullStopVolume = front.getPositionVailable(pos);
      this.checkFullStopList.direction = pos.direction;
      this.checkFullStopList.targetId = pos.targetId;
      if (this.checkFullStopVolume == 0) {
        utils.toast('可平手数为0,不能设置止盈止损单');
        return;
      }
      this.selectTids = pos.targetId;
      // console.log(front.targetIdMap);
      // var targetArr = front.targetIdMap[a];
      // this.selectTids = targetArr['targetSet'][0]['tid'];

      this.checkFullStopFlage = true;
      this.checkFullStopData = item;
      this.checkFullStopTitle = item.targetId;
      // this.$store.commit('changeView', item.targetId.code);
    },
    // 关闭止盈止损页面
    handleHiddenPage(e) {
      // e.stopPropagation();
      this.checkFullStopFlage = false;
    },
    handleCloseKey() {
      this.$refs.xxxx.blur();
      this.flage = false;
    },
    handleCloseKey2() {
      this.$refs.yyyy.blur();
      this.flage2 = false;
    },
    // #.更新资金信息
    onUpdateCapital(capital) {
      if (capital === undefined) {
        return;
      }
      // 交易顶部信息
      this.pageData.rights.value = Number(capital["balance"]).toFixed(2);
      this.pageData.usable.value = Number(capital["available"]).toFixed(2);
      this.pageData.account.value = capital["account"];
      // 资金列表
      this.$set(this.money, "权益", Number(capital["balance"]).toFixed(2));
      this.$set(this.money, "可用资金", Number(capital["available"]).toFixed(2));
      this.$set(this.money, "盈亏", (Number(capital["positionProfit"]) + Number(capital["closeProfit"])).toFixed(2));
      this.$set(this.money, "期初权益", Number(capital["preBalance"]).toFixed(2));
      this.$set(this.money, "平仓盈亏", Number(capital["closeProfit"]).toFixed(2));
      this.$set(this.money, "持仓盈亏", Number(capital["positionProfit"]).toFixed(2));
      this.$set(this.money, "保证金", Number(capital["currMargin"]).toFixed(2));
      this.$set(this.money, "冻结保证金", Number(capital["frozenMargin"]).toFixed(2));
      this.$set(this.money, "手续费", Number(capital["commission"]).toFixed(2));
      this.$set(this.money, "冻结手续费", Number(capital["frozenCommission"]).toFixed(2));
      this.$set(this.money, "今日出金", Number(capital["withdraw"]).toFixed(2));
      this.$set(this.money, "今日入金", Number(capital["deposit"]).toFixed(2));
    },

    // #.加载持仓信息
    onLoadPosition(posSet) {
      this.menuValue = [];
      if (posSet === undefined) return;
      for (var i = 0; i < posSet.length; ++i) {
        var pos = posSet[i];
        var volume = pos.todayVolume + pos.lastVolume;
        this.menuValue.push({
          targetId: pos.targetId,
          type: front.textPositionDirection(pos.direction),
          vol: volume,
          closeOut: volume - pos.frozenVolume,
          money: this.fmtDouble(pos.cost / volume / pos.multiple),
          loss: this.fmtDouble(pos.positionProfit),
          id: pos.id
        });
      }
      if (posSet.length <= this.insertPage.posSelect) {
        this.insertPage.posSelect = posSet.length - 1;
      }
      if (this.insertPage.posSelect != -1) {
        this.orderImfor(this.insertPage.posSelect);
      }
    },

    // #.更新持仓列表
    onUpdatePosition(pos, index) {
      if (pos === undefined) {
        this.menuValue = [];
        return;
      }
      var volume = pos.todayVolume + pos.lastVolume;
      var ui = {
        targetId: pos.targetId,
        type: front.textPositionDirection(pos.direction),
        vol: volume,
        closeOut: volume - pos.frozenVolume,
        money: this.fmtDouble(pos.cost / volume / pos.multiple),
        loss: this.fmtDouble(pos.positionProfit),
        id: pos.id
      };
      if (index == this.menuValue.length) {
        this.menuValue.push(ui);
      } else {
        this.menuValue[index] = ui;
      }
      if (this.checkFullStopList.targetId) {
        if (pos.targetId === this.checkFullStopList.targetId && pos.direction === this.checkFullStopList.direction) {
          this.checkFullStopVolume = pos.todayVolume + pos.lastVolume;
        }
        let flage = false;
        flage = this.menuValue.some(item=>{
          if(item.targetId==this.checkFullStopList.targetId && item.type==front.textPositionDirection(this.checkFullStopList.direction)){
              return true
          }
        })
        if (!flage) {
          this.checkFullStopVolume = '0'
        }
      }
    },

    // #.更新委托列表
    onUpdateOrder(order, index) {
      if (order === undefined) {
        this.orderMenuValue = [];
        return;
      }
      // console.log(order);
      var ui = {
        id: order.id,
        targetId: order.targetId,
        offset: front.textDirectionOffSet(order.direction, order.offset),
        price: this.fmtDouble(order.price),
        volume: order.volume,
        unvolume: order.volume - order.tradedVolume,
        insertTime: order.insertTime,
        state: front.textOrderState(order.state),
        orderId: order.orderId
      };
      if (this.orderMenuValue.length == index) {
        this.orderMenuValue.push(ui);
      } else {
        this.orderMenuValue[index] = ui;
      }
    },

    // #.更新撤单列表
    onUpdateCancelOrder(order, index) {
      if (order === undefined) {
        this.cancelOrderValue = [];
        return;
      }
      var ui = [
        order.targetId,
        front.textDirectionOffSet(order.direction, order.offset),
        order.price,
        order.volume,
        order.volume - order.tradedVolume
      ];
      if (this.cancelOrderValue.length <= index) {
        this.cancelOrderValue.push(ui);
      } else {
        this.cancelOrderValue[index] = ui;
      }
    },

    // #.更新撤单列表
    onRemoveCancelOrder(order, index) {
      this.cancelOrderValue.splice(index, 1);
    },

    // #.更新成交列表
    onUpdateTrade(trade, index) {
      if (trade === undefined) {
        this.tradeMenuValue = [];
        return;
      }
      var price = (trade.price*1000).toFixed(0)/1000;
      var ui = {
        targetId: trade.targetId,
        offset: front.textDirectionOffSet(trade.direction, trade.offset),
        price: price,
        tradedVolume: trade.volume,
        insertTime: trade.tradeTime,
        tradeId: trade.tradeId,
        orderId: trade.orderId
      };
      //this.tradeMenuValue.unshift(ui);
      this.tradeMenuValue.push(ui);
    },

    // 清空行情价格信息
    clearTickPrice() {
      this.insertPage.tick.latestPrice = "--";
      this.insertPage.tick.askPrice1 = "--";
      this.insertPage.tick.bidPrice1 = "--";
      this.insertPage.tick.askVolume1 = "--";
      this.insertPage.tick.bidVolume1 = "--";
      this.insertPage.inputPrice = "";
    },

    // 计算下单面板上的价格：根据价格类型
    updateButtonPrice() {
      // 计算下单面板上的价格：手动输入价格
      if (this.insertPage.inputPrice != "") {
        this.orderButton[0].price = this.insertPage.inputPrice;
        this.orderButton[1].price = this.insertPage.inputPrice;
        this.orderButton[2].price = this.insertPage.inputPrice;
        this.boardPrice = this.insertPage.inputPrice;
        return;
      }
      if (this.insertPage.priceMode == model.trader.latest_price_mode) {
        this.boardPrice=this.orderButton[0].price = this.insertPage.tick.latestPrice;
        this.orderButton[1].price = this.insertPage.tick.latestPrice;
      } else if (this.insertPage.priceMode == model.trader.queue_price_mode) {
        this.boardPrice=this.orderButton[0].price = this.insertPage.tick.bidPrice1;
        this.orderButton[1].price = this.insertPage.tick.askPrice1;
      } else if (this.insertPage.priceMode == model.trader.match_price_mode) {
        this.boardPrice=this.orderButton[0].price = this.insertPage.tick.askPrice1;
        this.orderButton[1].price = this.insertPage.tick.bidPrice1;
      } else if (this.insertPage.priceMode == model.trader.market_price_mode) {
        this.boardPrice=this.orderButton[0].price = this.insertPage.tick.highStopPrice;
        this.orderButton[1].price = this.insertPage.tick.lowStopPrice;
      } else if (this.insertPage.priceMode == model.trader.extend_price_mode) {
        this.boardPrice=this.orderButton[0].price = this.insertPage.tick.askPrice1;
        this.orderButton[1].price = this.insertPage.tick.bidPrice1;
      }
      // 1.手动选择合约，持仓价格不显示；2.平仓价格由价格类型决定。
      if (
        this.insertPage.posSelect == -1 ||
        this.insertPage.posSelect >= model.positionSet.array.length
      ) {
        this.orderButton[2].price = "";
      } else {
        var pos = model.positionSet.array[this.insertPage.posSelect];
        if (pos.direction == front.pos_direct_long) {
          this.orderButton[2].price = this.orderButton[1].price;
        } else {
          this.orderButton[2].price = this.orderButton[0].price;
        }
      }
    },

    // 全部平仓：将所有仓位全部平掉。
    onCloseAllPosition() {
      //model.trader.position.closeAll();
    },

    //下单提示信息
    show_hint(text) {
      this.warning = text;
      this.auto_flage = true;
      setTimeout(() => {
        this.auto_flage = false;
      }, 3000);
      return false;
    },
    show_cx(item, index) {
      this.store_name = item[0];
      this.store_type = item[1];
      this.store_num2 = item[2];
      this.store_num1 = item[3];
      this.store_money = item[4];
      this.data_cx = true;
      this.num = index;
    },

    sure_cd() {
      this.data_cx = false;
      var corder = new proto.ctpfront.proto.CancelOrder();
      corder.setOrderRef(model.cancelOrderSet.array[this.num].orderRef);
      corder.setOrderId(model.cancelOrderSet.array[this.num].orderId);
      corder.setExchangeId(model.cancelOrderSet.array[this.num].exchangeId);
      front.cancelOrder(
        corder,
        rsp => {},
        error => {
          this.show_hint(error.message);
        }
      );
    },

    all_cd() {
      var corder = new proto.ctpfront.proto.CancelOrder();
      for (var i = 0; i < model.cancelOrderSet.array.length; i++) {
        corder.setOrderRef(model.cancelOrderSet.array[i].orderRef);
        corder.setOrderId(model.cancelOrderSet.array[i].orderId);
        corder.setExchangeId(model.cancelOrderSet.array[i].exchangeId);
        front.cancelOrder(
          corder,
          rsp => {},
          error => {
            this.show_hint(error.message);
          }
        );
      }
      this.all_cx = false;
    },
    all_pcs() {
      const all = model.trader.position.closeAll();
      // 调用前置机委托下单。
      for (var i = 0; i < all.length; ++i) {
        var order = all[i];
        front.insertOrder(
          order,
          rsp => {},
          error => {
            this.show_hint(error.message);
            console.log(error)
            this.all_pc = false;
          }
        );
      }
      this.all_pc = false;
    },
    goBack() {
      // footerIndex = 2;
      window.history.back();
    },

    //下单事件
    orderClick(index, item) {
      this.quickHandle = null;
      this.quickFlage = false;
      this.insertPage.price = item.price;
      if (this.insertPage.price == "") {
        return; // 无价格则不显示下单确认界面。
      }
      this.orderIndex = index;
      if (this.insertPage.posSelect != -1) {
        var pos = model.positionSet.array[this.insertPage.posSelect];
        if (index == 2) {
          // if (this.$store.state.setPage.shortcutOpen) {
          //   this.purchaseOrder()
          // } else {
          //   this.sureOrder = true;
          // }
          if (localStorage.flage === "true") {
            this.sureOrder = true;
            this.eventflage = 'common';
          } else {
            this.purchaseOrder();
          }
          this.sele_deal =
            pos.direction == front.pos_direct_short ? "买" : "卖";
          this.closing = "平仓";
        } else {
          this.sele_deal = this.deal[index];
          if (localStorage.flage === "true") {
            this.sureOrder = true;
            this.eventflage = 'common';
          } else {
            this.purchaseOrder();
          }
          this.closing = "开仓";
        }
      } else {
        if (this.insertPage.targetId) {
          if (index < 2) {
            this.sele_deal = this.deal[index];
            if (localStorage.flage === "true") {
              this.sureOrder = true;
              this.eventflage = 'common';
            } else {
              this.purchaseOrder();
            }
            this.closing = "开仓";
          }
        } else {
          this.show_hint("请选择合约");
        }
      }
    },

    // 提示框不同事件
    clickEvent() {
      if (this.eventflage == 'shortcut_pc') {
        this.shortcutCloseOut(this.eventItem);
      } else if (this.eventflage == 'shortcut_fs') {
        this.shortcutCloseOut(this.eventItem);
        this.shortcutPosition(this.quickHandle);
      } else if (this.eventflage == 'shortcut_sc') {
        this.shortcutPosition(this.quickHandle);
      } else if (this.eventflage == 'common') {
        this.purchaseOrder();
      }
    },
    purchaseOrder(vol=null) {
      var that = this;
      var orderSet = [];
      var volume;
      if (vol) {
        volume = vol;
      } else {
        volume = that.insertPage.volume;
      }
      if (volume === undefined) volume = that.insertPage.volume;
      var price = that.insertPage.price;
      if (price === undefined) price = that.insertPage.price;
      var num = (this.insertPage.tick.priceTick * 10000000).toFixed(0) / 10000000
      if ((price * 10000000).toFixed(0) % (num * 10000000).toFixed(0) != 0) {
        this.show_hint("下单价格不符合该合约的最小变动价");
        return;
      }
      if (that.orderIndex == 0) {
        // 买开
        orderSet.push(
          front.makeOrder(
            that.insertPage.targetId,
            front.direct_buy,
            front.offset_open,
            volume,
            price
          )
        );
      } else if (that.orderIndex == 1) {
        // 卖开
        orderSet.push(
          front.makeOrder(
            that.insertPage.targetId,
            front.direct_sell,
            front.offset_open,
            volume,
            price
          )
        );
      } else if (that.orderIndex == 2) {
        // 平仓
        var pos = model.positionSet.array[that.insertPage.posSelect];
        front.getCloseOrderSet(orderSet, pos, volume, price);
      }

      // 调用前置机委托下单。
      for (var i = 0; i < orderSet.length; ++i) {
        var order = orderSet[i];
        front.insertOrder(
          order,
          rsp => {},
          error => {
              this.show_hint(error.message);
          }
        );
      }

      that.sureOrder = false;
    },
    //点击持仓数据
    orderImfor(index) {
      if (this.insertPage.posSelects == this.insertPage.posSelect && index == this.insertPage.posSelects) {
        this.insertPage.posSelect = '-1';
      } else {
      this.insertPage.posSelect = index;
        this.insertPage.posSelects = this.insertPage.posSelect
      }
      // console.log(this.menuValue[index]);
      if (!this.menuValue[index])return;
      var targetIds = this.menuValue[index].targetId;
      front.getMaxOrderVolume({targetId: targetIds,direct: front.direct_buy },resolve => {
        this.buyVol = resolve.maxVolume;
      });
      front.getMaxOrderVolume({targetId: targetIds,direct: front.direct_sell},resolve => {
        this.sellVol = resolve.maxVolume;
      });
      var pos = model.positionSet.array[index];
      // this.insertPage.posSelect = index;
      this.insertPage.inputPrice = "";
      this.insertPage.priceMode = model.trader.match_price_mode;
      this.insertPage.inputPriceHolder = this.price_type[
        model.trader.match_price_mode
      ];
      // 获取持仓可用数量
      this.insertPage.volume = front.getPositionVailable(pos);

      // 重新订阅合约
      var oldTargetId = this.insertPage.targetId;
      this.insertPage.targetId = pos.targetId;
      this.orderTick = front.subTick(pos.targetId, this.name);
      this.temporaryTick = front['targetSet'][pos.targetId];
      this.orderTicks = this.temporaryTick;
      this.$store.commit('priceTick/changePriceT', this.orderTicks.priceTick);
      if (oldTargetId !== pos.targetId) {
        front.unsubTick(oldTargetId, this.name);
      }
      this.insertPage.inputPriceHolder = "对手价";
    },
    isActiveValue() {
      this.isActive = this.$route.params.tableId;
      this.link(this.isActive);
    },

    link(index) {
      this.auto_flage = false;
      this.isActive = index;
      var that = this;
      if (index == 1) {
        this.menuTilte = [
          "合约",
          "多空",
          "手数",
          "可平",
          "开仓均价",
          "浮盈"
        ];
        that.buttonTitle = "全部平仓";
      } else if (index == 2) {
        this.menuTilte = ["合约", "类型", "委托价", "委托量", "挂单量"];
        this.buttonTitle = "全部撤单";
      } else if (index == 3) {
        that.buttonTitle = "银行转账";
      } else if (index == 4) {
        if (this.searchCheckedState == 0) {
          this.buttonSearch = true;
          this.menuTilte = [
            "合约",
            "开平",
            "成交价格",
            "成交手数",
            "成交时间",
            // "成交编号",
            // "报单编号"
          ];
        } else {
          this.buttonSearch = false;
          this.menuTilte = [
            "合约",
            "开平",
            "报单价格",
            "报单手数",
            "未成交数",
            "报单时间",
            "报单状态",
            // "报单编号"
          ];
        }
        this.buttonTitle = "成交查询";
        this.buttonTitle = "报单查询";

        // console.log(this.menuValue);
      } else if (index == 0) {
        this.menuTilte = [
          "合约",
          "多空",
          "手数",
          "可平",
          "开仓均价",
          "浮盈"
        ];
      }
    },
    loader_key() {
      var that = this;
      that.contractData = front.targetList;
    },
    //键盘选择合约时触发事件
    choiceTargetId(targetId) {
      this.$store.commit('keyBoard/changePriceFlage', false);
      this.insertPage.inputPrice = '';
      front.getMaxOrderVolume({targetId: targetId,direct: front.direct_buy },resolve => {
        this.buyVol = resolve.maxVolume;
      });
      front.getMaxOrderVolume({targetId: targetId,direct: front.direct_sell},resolve => {
        this.sellVol = resolve.maxVolume;
      });
      var oldTargetId = this.insertPage.targetId;
      this.insertPage.targetId = targetId;
      this.insertPage.posSelect = -1;
      this.insertPage.volume = 1;
      this.insertPage.priceMode = model.trader.match_price_mode;
      this.insertPage.inputPriceHolder = this.price_type[
        model.trader.match_price_mode
      ];
      this.orderTick = front.subTick(targetId, this.name);
      this.temporaryTick = front['targetSet'][targetId];
      // this.orderTicks = this.temporaryTick;
      this.$store.commit('priceTick/changePriceT', this.temporaryTick.priceTick);
      // console.log(art.digit(this.orderTick.priceTick))
      if (oldTargetId !== targetId) {
        front.unsubTick(oldTargetId, this.name);
      }
    },
    searchButLink(i) {
      this.searchCheckedState = i;
      if (i == 0) {
        this.menuTilte = [
          "合约",
          "开平",
          "成交价格",
          "成交手数",
          "成交时间",
          // "成交编号",
          // "报单编号"
        ];
        this.buttonSearch = true;
      } else if (i == 1) {
        this.menuTilte = [
          "合约",
          "开平",
          "报单价格",
          "报单手数",
          "未成交数",
          "报单时间",
          "报单状态",
          // "报单编号"
        ];
        this.buttonSearch = false;
      }
    },
    load(onFail) {
      if (onFail instanceof Function) {
        this.$router.push({ path: "/home/trade" });
        this.$refs.CheckFullStop.subTickData();
      }
    },
  },
  deactivated() {
    this.checkFullStopFlage = false;
    beferFooterIndex = 2;
    model.trader.queryCapital.stop();
    model.trader.position.unsubTick();
    front.unsubTick(this.insertPage.targetId, this.name);
  },
  //初始化事件
  activated() {
    front.autoMount(art.bind(this, this.load));
    // 初始化数据
    this.clearTickPrice();
    // 资金视图
    model.capital.attach(this.name, art.bind(this, this.onUpdateCapital));
    // 持仓视图
    model.positionSet.attach(
      this.name,
      art.bind(this, this.onUpdatePosition),
      art.bind(this, this.onLoadPosition)
    );
    // 委托视图
    model.orderSet.attach(this.name, art.bind(this, this.onUpdateOrder));
    // 撤单视图
    model.cancelOrderSet.attach(
      this.name,
      art.bind(this, this.onUpdateCancelOrder),
      undefined,
      art.bind(this, this.onRemoveCancelOrder)
    );
    // 成交视图
    model.tradeSet.attach(this.name, art.bind(this, this.onUpdateTrade));
    // 设定错误显示
    model.notify = art.bind(this, this.show_hint);

    // 设置页面默认值
    this.isActiveValue();
    this.loader_key();
    if (localStorage.contractorNo) {
      let contractorNo = localStorage.contractorNo;
      let localFlage = true;
      for(const i of this.menuValue) {
        if (i.targetId == contractorNo) {
          this.orderImfor(this.menuValue.indexOf(i));
          localFlage = false;
          break;
        }
      }
      if (localFlage) {
        this.choiceTargetId(contractorNo);
      }
      localStorage.removeItem("contractorNo");
    } else if (this.insertPage.targetId == "") {
      this.orderImfor(0);
    }

    // 订阅合约行情
    model.trader.queryCapital.start();
    model.trader.position.subTick();
    if (this.insertPage.targetId != "") {
      this.orderTick = front.subTick(this.insertPage.targetId, this.name);
    }
  },
  computed: {
    buttonClass(item) {},
  },
  watch: {
    // 委托下单视图
    orderTick: {
      handler: function(tick, old) {
        if (!tick.has) {
          this.clearTickPrice();
        } else {
          this.insertPage.tick = JSON.parse(JSON.stringify(tick));
        }
        this.updateButtonPrice();
      },
      deep: true
    },
    menuValue: {
      handler: function(news, old) {
        if (news.length == 0) {
          this.checkFullStopVolume = '0'
        }
      }
    }
  },
  beforeDestroy() {
    model.capital.detach(this.name);
    model.positionSet.detach(this.name);
    model.orderSet.detach(this.name);
    model.cancelOrderSet.detach(this.name);
    model.tradeSet.detach(this.name);
  }
};
</script>

<style>
.mint-button--primary {
  color: #dfdfdf;
  color: #fff;
  background-color: #ee3f44 !important;
}

.mint-button--default {
  background: rgba(196, 196, 196, 0.43);
  background: #3c4041;
  background: #ddd;
}
</style>

<style scoped>
.numbActive {
  background: #79d1ff;
}

.show_numb_box {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 5rem;
  right: 0;
  z-index: 999;
}

.numb_box {
  position: absolute;
  z-index: 10;
  background: #fff;
  width: 100%;
  bottom: 1rem;
  height: 4rem;
  overflow-y: scroll;
}

.nub_ggg {
  width: 70%;
  overflow: hidden;
  border-bottom: none;
}

.nub_ggg li {
  width: 32.3%;
  border-bottom: 1px solid #dadada;
  float: left;
  text-align: center;
  font-size: 0.44rem;
  display: block;
  color: #000;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
  border: 1px solid #dadada;
}

.nub_ggg li:active {
  background: #79d1ff;
}

.zj_x {
  border-left: 1px solid #dadada;
  border-right: 1px solid #dadada;
}

.nub_ggg li span {
  display: block;
  color: #e0e0e0;
  background: #e0e0e0;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
}

.nub_ggg li span.del img {
  width: 30%;
}

.numb_box2 {
  position: absolute;
  z-index: 10;
  background: #f5f5f5;
  width: 31%;
  bottom: 1rem;
  right: 0;
  height: 4rem;
  overflow-y: scroll;
}

.numb_box2 ul {
  border: 1px solid #dadada;
  overflow: hidden;
  border-bottom: none;
}

.numb_box2 ul li {
  width: 100%;
  border-bottom: 1px solid #dadada;
  float: left;
  text-align: center;
  font-size: 0.44rem;
  display: block;
  color: #000;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
}

.numb_box2 ul li:active {
  background: #79d1ff;
}

.numb_box3 {
  position: absolute;
  z-index: 10;
  background: #f5f5f5;
  width: 100%;
  bottom: 0px;
  height: 1rem;
}

.numb_box3 ul {
  border: 1px solid #dadada;
  overflow: hidden;
  border-bottom: none;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.numb_box3 ul li {
  width: 25%;

  border: 1px solid #dadada;
  text-align: center;
  font-size: 0.44rem;
  color: #000;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
}

.numb_box3 ul li:active {
  background: #79d1ff;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.36rem;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
  color: #a57518;
}

.menu {
  background: #1a1a1a;
  width: 100%;
  color: #fff;
  border-bottom: 1px solid #333;
}

.tobarContent {
  position: relative;
}

.tobarContent::after {
  content: "";
  position: absolute;
  bottom: -0.1rem;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #ff0100;
}

.order-w-1 {
  font-size: 0.32rem;
  color: #fff;
  background: #1f1f1f;
}

.border {
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  position: absolute;
  border: 1px solid #333;
  top: -50%;
  right: -50%;
  bottom: -50%;
  left: -50%;
  border-radius: 10px;
  background-color: #eee;
}

.menu ul {
  display: flex;
  justify-content: space-around;
  padding: 0.1rem 0;
  margin: 0;
}

.menu ul li {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding: 0.05rem 0;
  color: #888;
}

.menu ul li span {
  font-size: 0.28rem;
  display: inline-block;
  margin-top: -0.05rem;
}

.liActive {
  border-bottom: 3px solid #ff0100;
}

.trade-detail {
  font-size: 0.32rem;
  color: #fff;
  background: #1f1f1f;
}

.headerWrapper {
  background: #111;
  font-size: 0.32rem;
  height: 1.4rem;
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 0.2rem;
}
.goBack {
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 0.2rem;
  left: 0;
  z-index: 9;
}

.title-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0 0.05rem;
}

.title-left {
  padding-left: 0;
}

.title-center {
}

.title-right {
  padding-right: 0.1rem;
}

.label {
  font-size: 0.28rem;
  color: #999;
  margin-bottom: 0.02rem;
}

.left {
  position: absolute;
  left: 0.1rem;
  font-size: 0.32rem;
  top: 0.5rem;
  color: #fff;
  z-index: 10;
}

.right-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  height: 100%;
  padding-left: 0.7rem;
  overflow: hidden;
  gap: 0.1rem;
}

.span-value {
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
  letter-spacing: -0.01rem;
}

.order1-wrapper {
  border-bottom: 1px solid #ddd7ce;
  height: 1rem;
  color: #fff;
  font-size: 0.35rem;
  margin: 0 0.1rem 0 0.1rem;
}

.order-default {
  width: 2rem;
  background: #d3c9ca;
  height: 0.7rem;
  line-height: 0.7rem;
  margin: 0.15rem 0.2rem 0 0.1rem;
  text-align: center;
  float: left;
  border-radius: 3px;
}

.order-check {
  background: #7d2029;
}

.price-wrapper {
  min-height: 1.2rem;
  font-size: 0.3rem;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  margin: 0.1rem 0;
  padding: 0.1rem 0;
  background: #1a1a1a;
}

.price-wrapper span {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #bbb;
  font-size: 0.24rem;
}

.proces {
  font-style: normal;
  font-weight: bold;
  font-size: 0.36rem;
  margin-top: 0.05rem;
  color: #fff;
}

.buy {
  color: #ff2c1b;
}

.selt {
  color: #1ac31a;
}

.price-left {
  display: flex;
  width: 2rem;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid #333;
}

.price-left-icon {
  margin-right: 5px;
  font-size: 0.4rem;
}

.price-c-1 {
  margin-top: 0.05rem;
  color: #d4a017;
  font-size: 0.4rem;
}

.input-wrapper {
  height: 1rem;
  line-height: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  margin: 0 0.1rem 0 0.1rem;
}

.reduce {
  background: #fafafa;
  height: 0.7rem;
  width: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  border: 0 none;
  vertical-align: 3px;
  color: #757477;
}

.plus {
  background: #fafafa;
  height: 0.7rem;
  width: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  border: 1px solid #d6d6d6;
  color: #000;
}

.imput {
  background: #fff;
  height: 0.8rem;
  width: 100%;
  border: 1px solid #444;
  margin: 0 0.1rem;
  line-height: 0.8rem;
  white-space: nowrap;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 0 0.1rem;
}

.value {
  border: 0 none;
  height: 100%;
  color: #333;
  width: 100%;
  outline: none;
  font-size: 0.32rem;
  background: transparent;
  text-align: center;
}

.place_wrapper {
  height: 1.5rem;
  display: flex;
  justify-content: space-around;
  padding: 0.1rem;
  box-sizing: border-box;
}

.place_oreder {
  width: 31%;
  height: 1.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 0.3rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  padding: 0.05rem 0;
}

.place_oreder p {
  width: 100%;
  height: 0.45rem;
  text-align: center;
  line-height: 0.45rem;
  overflow: hidden;
  margin: 0;
}

.place_oreder span {
  width: 80%;
  height: 1px;
  background-color: rgba(255,255,255,0.3);
  margin: 0.05rem 0;
}

.place_oreder p:last-child {
  font-weight: bold;
}

.bd-t {
  position: relative;
}

.place_oreder span::before {
  content: "  ";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  background-color: #fff;
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.order_content {
  width: 100%;
  overflow-y: auto;
  position: absolute;
  top: 8.1rem;
  bottom: 0;

  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.order {
  width: 94%;
  height: 0.9rem;
  line-height: 0.9rem;
  position: absolute;
  bottom: 0.15rem;
  left: 3%;
  background-color: #ef3f44;
  color: #fff;
  border-radius: 4px;
  font-size: 0.32rem;
  border: none;
  text-align: center;
  box-shadow: 0 2px 6px rgba(239, 63, 68, 0.3);
}

.order:active {
  background-color: #d3353a;
  box-shadow: none;
}

.order-money {
  width: 94%;
  height: 0.9rem;
  line-height: 0.9rem;
  position: absolute;
  bottom: 0.15rem;
  left: 3%;
  background-color: #ef3f44;
  color: #fff;
  border-radius: 4px;
  font-size: 0.32rem;
  border: none;
  text-align: center;
}

.order-left {
  width: 46%;
  height: 0.9rem;
  line-height: 0.9rem;
  position: absolute;
  bottom: 0.15rem;
  left: 3%;
  background-color: #1a1a1a;
  color: #888;
  border-radius: 4px 0 0 4px;
  border: 1px solid #333;
}

.order-right {
  width: 46%;
  height: 0.9rem;
  line-height: 0.9rem;
  position: absolute;
  bottom: 0.15rem;
  right: 3%;
  background-color: #1a1a1a;
  color: #888;
  border-radius: 0 4px 4px 0;
  border: 1px solid #333;
}

.store-c-1 {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background: #161616;
  height: 0.9rem;
  line-height: 0.9rem;
  padding: 0 0.1rem;
  position: absolute;
  top: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #333;
  z-index: 5;
}

.order-w-1 .store-c-1 {
  top: 7.2rem;
}

.store-c-1 span {
  text-align: center;
  font-size: 0.32rem;
  white-space: nowrap;
  flex: 1;
  color: #efefef;
  font-weight: bold;
}

.store-c-1 span:nth-child(1) {
  flex: 1.2;
}

.store-c-1 span:nth-child(6) {
  flex: 1.2;
}

.cancel-order-wrapper {
  overflow: scroll;
  position: absolute;
  width: 100%;
  top: 3.3rem;
  bottom: 1rem;

  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.store-c-2 {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  min-height: 0.8rem;
  color: #fff;
  padding: 0 0.1rem;
  position: relative;
}

.store-c-2::after {
  content: "  ";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #333;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.options {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 0;
  font-size: 0.25rem;
  line-height: 0.9rem;
  background: #2a2e37;
  transition: all 0.2s;
  overflow: hidden;
}
.options span {
  flex: 1;
  height: 0;
  opacity: 0;
  display: none;
  text-align: center;
  border-left: 1px solid #3d4450;
  transition: all 0.4s;
  color: #ccc;
}
.showOptions {
  height: 0.9rem;
}
.showOptions span {
  height: 0.9rem;
  opacity: 1;
  display: inline;
}
.options span:nth-child(1) {
  border: 0 none;
}
.store-c-2 span {
  flex: 1;
  text-align: center;
  font-size: 0.26rem;
  white-space: nowrap;
  padding: 0.1rem 0;
}

.store-c-2 span:nth-child(1) {
  flex: 1.2;
}

.store-c-2 span:nth-child(6) {
  flex: 1.2;
}

.store-cx {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.store-cx-con {
  width: 80%;
  height: 5rem;
  background: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  box-shadow: 0 5px 15px #333;
  border-radius: 0.1rem;
}

.tit {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  padding-left: 0.3rem;
  color: #26a2ff;
}

.store-con {
  color: #000;
  line-height: 0.8rem;
  padding-left: 0.3rem;
}

.store-click {
  height: 1rem;
  width: 100%;
  border-top: 1px solid #dedede;
  position: absolute;
  bottom: 0;
  left: 0;
}

.store-cancel {
  width: 50%;
  height: 1rem;
  border: 0 none;
  float: left;
}

.store-enter {
  width: 50%;
  height: 1rem;
  border: 0 none;
}

.all_tit {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  text-align: center;
  color: #26a2ff;
}

.money-w-1 {
  height: 1.5rem;
  color: #fff;
  width: 49.9999999999%;
  position: relative;
  display: inline-block;
}

.money-w-1::after {
  content: "  ";
  position: absolute;
  left: 0;
  top: 1.5rem;
  width: 100%;
  height: 1px;
  background-color: #fff;
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleY(0.1);
  transform: scaleY(0.1);
}

.money-w-1:nth-child(even)::before {
  content: "  ";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 1.5rem;
  background-color: #fff;
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleX(0.1);
  transform: scaleX(0.1);
}

.money-c-1 {
  height: 100%;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0.25rem;
}

.money-c-line {
  border-right: 1px solid #ddd7ce;
  height: 1.3rem;
  width: 1px;
  display: inline-block;
  margin-top: 0.1rem;
}

.money-c-value {
  font-weight: bold;
  color: #fff;
  margin-top: 0.1rem;
  display: inline-block;
}

.search-checked {
  color: #dfdfdf;
  background-color: #ee3f44;
}

.store-c-1-search {
  width: auto;
  overflow: scroll;
  white-space: nowrap;
  background: #f8f9fa;
  line-height: 1rem;
  font-size: 0.25rem;
  border-bottom: 1px solid #ddd7ce;
}

.store-c-1-search span {
  margin: 0 0.25rem;
  width: 1rem;
}

.search-content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background: #fff;
  height: 1rem;
  font-size: 0.25rem;
  border-bottom: 1px solid #ddd7ce;
  color: #383838;
  width: 16rem;
  padding: 0 0.2rem 0.2rem;
}

.search {
  overflow: scroll;
  -webkit-overflow-scrolling: auto;
}

table,
td,
th {
  text-align: center;
}

.search table {
  width: 15rem;
  border-collapse: collapse;
  overflow: scroll;
}

.search table tr {
  height: 1rem;
  line-height: 1rem;
}

.search table tr th {
  font-size: 0.28rem;
  border-bottom: 0.5px solid #ddd7ce;
}

.search table tr td {
  font-size: 0.28rem;
  color: #fff;
  position: relative;
}

.search table tr td::after {

  content: "  ";
  position: absolute;
  left: 0;
  top: 1rem;
  width: 100%;
  height: 1px;
  background-color: #fff;
  /*background-color: #202228;*/
  /* 如果不用 background-color, 使用 border-top:1px solid #e0e0e0; */
  -webkit-transform: scaleY(0.1);
  transform: scaleY(0.1);
}

.search-content {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background: #fff;
  height: 1rem;
  font-size: 0.25rem;
  border-bottom: 1px solid #ddd7ce;
  color: #383838;
  width: 16rem;
  padding: 0 0.2rem 0.2rem;
}

.orderText {
  width: 100%;
  height: 0.65rem;
  color: #1f1f1f;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.orderText p {
  height: 0.65rem;
  line-height: 0.65rem;
  float: left;
  margin-left: 0.2rem;
}

.orderText i {
  height: 0.65rem;
  line-height: 0.65rem;
}

.sele_bg {
  background-color: #faffbd;
  color: #3c4041;
}

.vessel {
  width: 100%;
  position: absolute;
  top: 2.3rem;
  bottom: 1.1rem;
  left: 0;
  right: 0;
  overflow: scroll;

  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.vessel table tr th {
  font-size: 0.28rem;
}

.alert_imfor {
  width: 5rem;
  line-height: 0.6rem;
  background: skyblue;
  border-radius: 0.3rem;
  font-size: 0.3rem;
  text-align: center;
  position: absolute;
  bottom: 2rem;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 999;
  padding: 0.1rem;
  color: #60683e;
}

.shadow2 {
  width: 100%;
  position: absolute;
  top: 3.3rem;
  bottom: 1.1rem;
  left: 0;
  right: 0;
  z-index: 2;
  overflow-y: auto;
  background: #1f1f1f;
  color: #fff;
  font-size: 0.28rem;

  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}

.orderText > span {
  font-size: 0.24rem;
  /*margin:0 0.18rem;*/
  width: 25%;
}

.select_t {
  width: 100%;
  height: 0.75rem;
  border-top: 1px solid #cdcdcd;
  font-size: 0.3rem;
  color: #1f1f1f;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.select_t > span {
  width: 20%;
  float: left;
  text-align: center;
}

.or_color {
  color: red;
}

.green_color {
  color: #1ac31a;
}

.character {
  background: #dedede;
  font-size: 0.46rem;
  color: #6b6b6b;
}

.point {
  padding-bottom: 0.1rem;
}
/* 止盈止损 */
.CheckFullStop {
  width: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  background: #20222b;
  transition: all 0.3s;
  z-index: 9;
  overflow: hidden;
}
.showPage {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/TradeDetail/TradeDetail.vue